import api from '../utils/api';

// Get all assistants
export const getAllAssistants = async () => {
  try {
    const response = await api.get('/assistants');
    return response.data;
  } catch (error) {
    console.error('Error fetching assistants:', error);
    throw error;
  }
};

// Get assistant by ID
export const getAssistantById = async (id) => {
  try {
    const response = await api.get(`/assistants/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching assistant ${id}:`, error);
    throw error;
  }
};

// Create a new assistant
export const createAssistant = async (assistantData) => {
  try {
    const response = await api.post('/assistants', assistantData);
    return response.data;
  } catch (error) {
    console.error('Error creating assistant:', error);
    throw error;
  }
};

// Update assistant
export const updateAssistant = async (id, assistantData) => {
  try {
    const response = await api.put(`/assistants/${id}`, assistantData);
    return response.data;
  } catch (error) {
    console.error(`Error updating assistant ${id}:`, error);
    throw error;
  }
};

// Delete assistant
export const deleteAssistant = async (id) => {
  try {
    const response = await api.delete(`/assistants/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting assistant ${id}:`, error);
    throw error;
  }
};

// Send message to assistant
export const sendMessage = async (id, message, context) => {
  try {
    const response = await api.post(`/assistants/${id}/message`, {
      message,
      context
    });
    return response.data;
  } catch (error) {
    console.error(`Error sending message to assistant ${id}:`, error);
    throw error;
  }
};

// Get instances for an assistant
export const getAssistantInstances = async (id) => {
  try {
    const response = await api.get(`/assistants/${id}/instances`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching instances for assistant ${id}:`, error);
    throw error;
  }
};

// Add instances to an assistant
export const addInstancesToAssistant = async (id, instanceIds) => {
  try {
    const response = await api.post(`/assistants/${id}/instances`, {
      instance_ids: instanceIds
    });
    return response.data;
  } catch (error) {
    console.error(`Error adding instances to assistant ${id}:`, error);
    throw error;
  }
};

// Remove instances from an assistant
export const removeInstancesFromAssistant = async (id, instanceIds) => {
  try {
    const response = await api.delete(`/assistants/${id}/instances`, {
      data: { instance_ids: instanceIds }
    });
    return response.data;
  } catch (error) {
    console.error(`Error removing instances from assistant ${id}:`, error);
    throw error;
  }
};

// Start assistant (set status to active)
export const startAssistant = async (id) => {
  try {
    const response = await api.put(`/assistants/${id}`, {
      status: 'active'
    });
    return response.data;
  } catch (error) {
    console.error(`Error starting assistant ${id}:`, error);
    throw error;
  }
};

// Stop assistant (set status to inactive)
export const stopAssistant = async (id) => {
  try {
    const response = await api.put(`/assistants/${id}`, {
      status: 'inactive'
    });
    return response.data;
  } catch (error) {
    console.error(`Error stopping assistant ${id}:`, error);
    throw error;
  }
};

// Get statistics for an assistant
export const getAssistantStats = async (id) => {
  try {
    const response = await api.get(`/assistants/${id}/stats`);
    return response.data;
  } catch (error) {
    console.error(`Error getting statistics for assistant ${id}:`, error);
    throw error;
  }
};

// Get assistants page data
export const getAssistantsPageData = async (id) => {
  try {
    const response = await api.get('/assistants/pageData');
    return response.data;
  } catch (error) {
    console.error('Error fetching assistants page data:', error);
    throw error;
  }
};

// Get integrations for an assistant
export const getAssistantIntegrations = async (id) => {
  try {
    const response = await api.get(`/assistants/${id}/integrations`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching integrations for assistant ${id}:`, error);
    throw error;
  }
};

// Add integrations to an assistant
export const addIntegrationsToAssistant = async (id, integrationIds) => {
  try {
    const response = await api.post(`/assistants/${id}/integrations`, {
      integration_ids: integrationIds
    });
    return response.data;
  } catch (error) {
    console.error(`Error adding integrations to assistant ${id}:`, error);
    throw error;
  }
};

// Remove integrations from an assistant
export const removeIntegrationsFromAssistant = async (id, integrationIds) => {
  try {
    const response = await api.delete(`/assistants/${id}/integrations`, {
      data: { integration_ids: integrationIds }
    });
    return response.data;
  } catch (error) {
    console.error(`Error removing integrations from assistant ${id}:`, error);
    throw error;
  }
};
